export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./InternalBanner.vue?vue&type=template&id=3b4a9e5e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/InternalBanner.vue?vue&type=template&id=3b4a9e5e&scoped=true&
// module id = 102
// module chunks = 0